var Handlebars = require("../../../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isHit : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<span class=\"fr-preview-word\">\n             <a class=\"fr-preview-hit\" title=\""
    + alias2(alias1((depth0 != null ? depth0.word : depth0), depth0))
    + "\" role=\"button\" href=\""
    + alias2(alias1((depth0 != null ? depth0.word : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.word : depth0), depth0))
    + "</a>\n        </span>";
},"4":function(container,depth0,helpers,partials,data) {
    return "<span class=\"fr-preview-word\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.word : depth0), depth0))
    + "</span>";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.words : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/hitRow/textPreview/template.hbs
 ** module id = 627
 ** module chunks = 0
 **/